/**
 * Environment Configuration
 * Centralized configuration for all API endpoints and environment variables
 */

// Get URLs from environment variables with fallbacks
const getUserServiceUrl = () => {
  return process.env.REACT_APP_USER_URL || "https://userservice.comsensetechnologies.com";
  // return process.env.REACT_APP_USER_URL || "http://10.200.40.22:1004";
};

const getUrlShortenServiceUrl = () => {
  return process.env.REACT_APP_URL_SHORTEN || "https://urlshortner.comsensetechnologies.com";
  // return process.env.REACT_APP_URL_SHORTEN || "http://10.200.40.22:1001";
};

// API Base URLs
export const API_URLS = {
  // User Management Service
  USER_SERVICE: getUserServiceUrl(),
  
  // URL Shortening Service
  URL_SHORTEN_SERVICE: getUrlShortenServiceUrl()
};

// Legacy exports for backward compatibility
export const USER_URL = API_URLS.USER_SERVICE;
export const URL_SHORTEN = API_URLS.URL_SHORTEN_SERVICE;

// Environment-specific configurations
export const ENV_CONFIG = {
  // Development
  development: {
    USER_SERVICE: getUserServiceUrl(),
    URL_SHORTEN_SERVICE: getUrlShortenServiceUrl()
  },
  
  // Production
  production: {
    USER_SERVICE: getUserServiceUrl(),
    URL_SHORTEN_SERVICE: getUrlShortenServiceUrl()
  },
  
  // Staging (if needed)
  staging: {
    USER_SERVICE: getUserServiceUrl(),
    URL_SHORTEN_SERVICE: getUrlShortenServiceUrl()
  }
};

// Get current environment (defaults to development)
const getCurrentEnvironment = () => {
  return process.env.NODE_ENV || 'development';
};

// Get environment-specific URLs
export const getEnvironmentUrls = () => {
  const env = getCurrentEnvironment();
  return ENV_CONFIG[env] || ENV_CONFIG.development;
};

// Default export with all URLs
const environmentConfig = {
  ...API_URLS,
  USER_URL,
  URL_SHORTEN,
  getEnvironmentUrls
};

export default environmentConfig;
